import { useCallback, useState } from "react";
import { useNotify } from "react-admin";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { studentRequests } from "api/studentApi";
import { getFileFromUrl } from "server/components/DownloadFile";
import { settings } from "app";
import LoadingActionButton from "server/components/LoadingActionButton";

const GenerateExamProtocolButton = ({ sessionExamId }) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const generateProtocol = useCallback(async () => {
    setLoading(true);
    const url = `${settings.gatewayApi}/${studentRequests.getGeneralExamProtocol(sessionExamId)}`;

    await getFileFromUrl(url, `general-exam-protocol-${sessionExamId}`, notify);

    setLoading(false);
  }, [sessionExamId, notify]);

  return (
    <LoadingActionButton
      label="Генерирай протокол"
      icon={<FileDownloadIcon />}
      onClick={generateProtocol}
      loading={loading}
    />
  );
};

export default GenerateExamProtocolButton;
